// extracted by mini-css-extract-plugin
module.exports = {"section":"richText-module--section--ifclJ","title":"richText-module--title--15NN4"};